/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { actions } from '../../redux/reducers/unused.access/summary'
import { Switch, useRouteMatch } from 'react-router-dom'
import { Route } from '../shell/helpers/router.helper'
import { DetailsRoutes } from './configurations/details.routes'
import loadable from '@loadable/component'
import Loading from '@src/components/loading'

interface OwnProps {}

export type Props = OwnProps
export interface State {}

const UnusedAccessDetailsLoadableComponent = loadable(
  () => import('./views/details'),
  {
    fallback: <Loading />
  }
)

const UnusedAccessSummaryLoadableComponent = loadable(
  () => import('./views/summary'),
  {
    fallback: <Loading />
  }
)

const UnusedAccessPage: React.FC<Props> = React.memo((props: Props) => {
  const match = useRouteMatch()
  const dispatch = useDispatch()
  useEffect(
    () => () => {
      //unmount
      dispatch(actions.dispose())
    },
    []
  )
  return (
    <Switch>
      <Route
        exact
        path={DetailsRoutes.byRole}
        component={UnusedAccessDetailsLoadableComponent}
      />
      <Route
        exact
        path={DetailsRoutes.byIdentityWithoutRole}
        component={UnusedAccessDetailsLoadableComponent}
      />
      <Route
        exact
        path={DetailsRoutes.byIdentity}
        component={UnusedAccessDetailsLoadableComponent}
      />

      <Route
        exact
        path={DetailsRoutes.byIdentityWithRole}
        component={UnusedAccessDetailsLoadableComponent}
      />

      <Route
        withFilter
        path={match?.url}
        component={UnusedAccessSummaryLoadableComponent}
      />
    </Switch>
  )
})

export default UnusedAccessPage
